
import axios from "../utils/request";
import qs from "qs";

let userInfo = {
  upload: (data) => {
    return axios({
      method: "post",
      url: "/admin/v1/systemFileUpload",
      data,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  yun76: (scene_name) => {
    return axios({
      method: "post",
      url: "/admin/v1/getUploadToken",
      data: {
        model_name: 'admin',
        scene_name: scene_name
      }
    })
  },
  logout: (info) => { //登录
    return axios({
      method: "post",
      url: "/admin/v1/adminLogin",
      data: info
    })
  },
  getUserInfo: () => { //获取个人详情
    return axios({
      method: "get",
      url: "/admin/v1/getUserInfo",
    })
  },
  userUpdatePwd: (data) => {
    return axios({
      method: "post",
      url: "/admin/v1/userUpdatePwd",
      data: data
    })
  },
  getPhoneCode: (data) => {
    return axios({
      method: "get",
      url: "/admin/v1/getPhoneCode",
      params: data
    })
  },




  adminRole: (info) => { //获取角色详情
    return axios({
      method: "get",
      url: "/admin/v1/adminRole/" + info,
    })
  },
  adminRole1: (info) => { //获取角色列表
    return axios({
      method: "get",
      url: "/admin/v1/adminRole",
      params: info
    })
  },
  adminRole2: (info, id) => { //编辑角色
    return axios({
      method: "put",
      url: "/admin/v1/adminRole/" + id,
      // data:qs.stringify(info)
      data: info
    })
  },
  adminRole3: (info) => { //创建角色
    return axios({
      method: "post",
      url: "/admin/v1/adminRole",
      data: info
    })
  },
  adminRole4: (ids) => { //删除角色           
    return axios({
      method: "delete",
      url: "/admin/v1/adminRole/" + ids,
    })
  },
  selectionList: (info) => { //获取区域列表
    return axios({
      method: "get",
      url: "/admin/v1/adminArea",
      params: info
    })
  },
  systemSelectionList: () => { //获取系统区域列表
    return axios({
      method: "get",
      url: "/admin/v1/systemAreaList",
    })
  },
  createArea: (info) => { //创建区域
    return axios({
      method: "post",
      url: "/admin/v1/adminArea",
      data: info
    })
  },
  createArea1: (info, id) => { //编辑区域
    return axios({
      method: "put",
      url: "/admin/v1/adminArea/" + id,
      data: info
    })
  },
  createArea2: (info) => { //删除区域   
    return axios({
      method: "delete",
      url: "/admin/v1/adminArea/" + info,
    })
  },
  createArea3: (info) => { //获取区域列表   
    return axios({
      method: "get",
      url: "/admin/v1/adminArea/" + info,
    })
  },
  systemUser: (info) => { //获取用户列表
    return axios({
      method: "get",
      url: "/admin/v1/adminUser",
      params: info
    })
  },
  systemUser1: (info) => { //获取用户详情
    return axios({
      method: "get",
      url: "/admin/v1/adminUser/" + info,
    })
  },
  systemUser2: (info) => { //创建用户
    return axios({
      method: "post",
      url: "/admin/v1/adminUser",
      data: info
    })
  },

  systemUser3: (info, id) => { //编辑用户
    return axios({
      method: "put",
      url: "/admin/v1/adminUser/" + id,
      data: info
    })
  },
  userResetPhone: (info) => { //创建用户
    return axios({
      method: "post",
      url: "/admin/v1/userResetPhone",
      data: info
    })
  },
  systemUser4: (ids) => { //编辑用户
    return axios({
      method: "delete",
      url: "/admin/v1/adminUser/" + ids,
    })
  },
  adminUserResetPwd: (ids) => { //编辑用户
    return axios({
      method: "put",
      url: "/admin/v1/adminUserResetPwd/" + ids,
    })
  },
  serviceCallLog: (data) => {
    return axios({
      method: "get",
      url: "/admin/v1/callLog",
      params: data,
      responseType: data.flag == 'export' ? 'blob' : ''
    })
  },
  serviceCallDel: (data) => {
    return axios({
      method: "delete",
      url: "/admin/v1/callLog/" + data.call_log_id
    })
  },
  serviceUserList: (data) => {
    return axios({
      method: "get",
      url: "/admin/v1/serviceUser",
      params: data,
      responseType: data.flag == 'export' ? 'blob' : ''
    })
  },
  serviceUserSignList: (data) => {
    return axios({
      method: "get",
      url: "/admin/v1/serviceUserSignLog",
      params: data
    })
  },
  userActivityEnrollList: (data) => {
    return axios({
      method: "get",
      url: "/admin/v2/userActivityEnrollList/" + data.userId,
      params: data
    })
  },
  userRecruitmentDeliveryList: (data) => {
    return axios({
      method: "get",
      url: "/admin/v2/userRecruitmentDeliveryList/" + data.userId,
      // params: data
    })
  },
  serviceUserEdit: (data) => {
    return axios({
      method: "put",
      url: "/admin/v1/serviceUser/" + data.user_id,
      data: data
    })
  },
  serviceUserAdd: (data) => {
    return axios({
      method: "POST",
      url: "/admin/v1/serviceUser",
      data
    })
  },
  serviceUserDel: (data) => {
    return axios({
      method: "delete",
      url: "/admin/v1/serviceUser/" + data.user_id,
      data: data
    })
  },
  serviceUserNotice: (data) => {
    return axios({
      method: "post",
      url: "/admin/v1/serviceUserNotice",
      data: data
    })
  },
  customerList: (data) => {
    return axios({
      method: "get",
      url: "/admin/v1/customer",
      params: data,
      responseType: data.flag == 'export' ? 'blob' : ''
    })
  },
  customerService: (data) => {
    return axios({
      method: "get",
      url: "/admin/v1/customerService",
      params: data,
      responseType: data.flag == 'export' ? 'blob' : ''
    })
  },
  serviceCustomerDel: (data) => {
    return axios({
      method: "delete",
      url: "/admin/v1/customer/" + data.customer_id
    })
  },
  serviceCustomerEdit: (data) => {
    return axios({
      method: "put",
      url: "/admin/v1/customer/" + data.customer_id,
      data
    })
  },
  serviceCustomerDetail: (data) => {
    return axios({
      method: "get",
      url: "/admin/v1/customer/" + data.customer_id
    })
  },
  systemFileDownload: (data) => {
    return axios({
      method: "get",
      url: "/admin/v1/systemFileDownload",
      params: data,
      responseType: 'blob'
    })
  },
  customerImport: (data) => {
    return axios({
      method: "post",
      url: "/admin/v1/customerImport",
      data,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  customerAllocation: (data) => {
    return axios({
      method: "put",
      url: "/admin/v1/customerAllocation/" + data.user_id + '/' + data.customer_id,
      data: data
    })
  },
  serviceLogList: (data) => {
    return axios({
      method: "get",
      url: "/admin/v1/serviceLog",
      params: data,
      responseType: data.flag == 'export' ? 'blob' : ''
    })
  },
  serviceLogDel: (data) => {
    return axios({
      method: "delete",
      url: "/admin/v1/serviceLog/" + data.service_log_id
    })
  },

  followUpReply: (data) => {
    return axios({
      method: "post",
      url: "/admin/v1/followUpReply",
      data
    })
  },
  followUpReplyList: (data) => {
    return axios({
      method: "get",
      url: "/admin/v1/followUpReply",
      params: data
    })
  },
  followUpReplyDelete: (data) => {
    return axios({
      method: "delete",
      url: "/admin/v1/followUpReply/" + data.reply_id
    })
  },
  serviceLogDetail: (data) => {
    return axios({
      method: "get",
      url: "/admin/v1/serviceLog/" + data.service_log_id,
    })
  },
  serviceState: (data) => {
    return axios({
      method: "put",
      url: "/admin/v1/serviceLog/" + data.service_log_id + '/' + data.status,
      data: data
    })
  },

  serviceCommentList: (data) => {
    return axios({
      method: "get",
      url: "/admin/v1/commentReply",
      params: data
    })
  },
  serviceCommentAdd: (data) => {
    return axios({
      method: "post",
      url: "/admin/v1/commentReply",
      data: data
    })
  },
  serviceCommentDel: (data) => {
    return axios({
      method: "delete",
      url: "/admin/v1/commentReply/" + data.reply_id,
    })
  },
  serviceStar: (data) => {
    return axios({
      method: "put",
      url: "/admin/v2/serviceComment/" + data.service_log_id + '/' + data.comment_id + '/' + data.comment_level,
    })
  },

  customerFollowUpLogList: (data) => {
    return axios({
      method: "get",
      url: "/admin/v1/customerFollowUpLogList",
      params: data
    })
  },
  commentReplyList: (data) => {
    return axios({
      method: "get",
      url: "/admin/v1/commentReply",
      params: data
    })
  },


  serviceProjectList: (data) => {
    return axios({
      method: "get",
      url: "/admin/v1/serviceProject",
      params: data
    })
  },
  serviceProjectDel: (data) => {
    return axios({
      method: "delete",
      url: "/admin/v1/serviceProject/" + data.project_id,
      data: data
    })
  },
  serviceProjectState: (data) => {
    return axios({
      method: "delete",
      url: "/admin/v1/serviceProject/" + data.project_id,
    })
  },
  serviceProjectList: (data) => {
    return axios({
      method: "get",
      url: "/admin/v1/serviceProject",
      params: data
    })
  },
  serviceProjectEdit: (data) => {
    return axios({
      method: "put",
      url: "/admin/v1/serviceProject/" + data.project_id,
      data: data
    })
  },
  serviceProjectUpdate: (data) => {
    return axios({
      method: "put",
      url: "/admin/v1/serviceProject/" + data.project_id + "/" + data.status
    })
  },
  serviceProjectAdd: (data) => {
    return axios({
      method: "post",
      url: "/admin/v1/serviceProject",
      data: data
    })
  },


  serviceCategoryList: (data) => {
    return axios({
      method: "get",
      url: "/admin/v1/serviceCategory",
      params: data
    })
  },
  serviceCategoryEdit: (data) => {
    return axios({
      method: "put",
      url: "/admin/v1/serviceCategory/" + data.category_id,
      data: data
    })
  },
  serviceCategoryAdd: (data) => {
    return axios({
      method: "post",
      url: "/admin/v1/serviceCategory",
      data: data
    })
  },
  serviceCategoryDel: (data) => {
    return axios({
      method: "delete",
      url: "/admin/v1/serviceCategory/" + data.category_id
    })
  },

  recycleList: (data) => {
    return axios({
      method: "get",
      url: "/admin/v1/recycle",
      params: data
    })
  },
  recycleBack: (data) => {
    return axios({
      method: "put",
      url: "/admin/v1/recycle/" + data.flag + '/' + data.key_id,
    })
  },
  recycleDel: (data) => {
    return axios({
      method: "delete",
      url: "/admin/v1/recycle/" + data.flag + '/' + data.key_id,
    })
  },

  getDateList: (data) => {
    return axios({
      method: "get",
      url: "/admin/v2/getDateList"
    })
  },
  serviceStateV2: (data) => {
    return axios({
      method: "put",
      url: "/admin/v2/serviceLog/" + data.customer_id + '/' + data.status,
      data: data
    })
  },
  
  
  // 活动
  getActivityList: (data) => {
    return axios({
      method: "get",
      url: "/admin/v2/activity",
      params: data
    })
  },
  getActivityDetail: (activityId) => {
    return axios({
      method: "get",
      url: "/admin/v2/activity/"+activityId
    })
  },
  addActivity: (data) => {
    return axios({
      method: "post",
      url: "/admin/v2/activity",
      data
    })
  },
  updateActivity: (activityId, data) => {
    return axios({
      method: "put",
      url: "/admin/v2/activity/"+activityId,
      data
    })
  },
  delActivity: (activityId) => {
    return axios({
      method: "DELETE",
      url: "/admin/v2/activity/" + activityId
    })
  },
 updateEnroll: (activityEnrollId, data) => {
    return axios({
      method: "PUT",
      url: "/admin/v2/activityEnroll/" + activityEnrollId,
      data
    })
  },
  
  
  // 招聘
  getRecruitIdList: (data) => {
    return axios({
      method: "get",
      url: "/admin/v2/recruitment",
      params: data
    })
  },
  getRecruitDetail: (recruitId) => {
    return axios({
      method: "get",
      url: "/admin/v2/recruitment/"+recruitId
    })
  },
  addRecruit: (data) => {
    return axios({
      method: "post",
      url: "/admin/v2/recruitment",
      data
    })
  },
  updateRecruit: (recruitId, data) => {
    return axios({
      method: "put",
      url: "/admin/v2/recruitment/"+recruitId,
      data
    })
  },
  delRecruit: (recruitId) => {
    return axios({
      method: "DELETE",
      url: "/admin/v2/recruitment/" + recruitId
    })
  },
   updateApplicant: (deliveryId, data) => {
      return axios({
        method: "PUT",
        url: "/admin/v2/recruitmentDelivery/" + deliveryId,
        data
      })
    },
  // 咨询
  
   addInformation: (data) => {
     return axios({
       method: "POST",
       url: "/admin/v2/information",
       data
     })
   },
  getInformationList: (data) => {
    return axios({
      method: "get",
      url: "/admin/v2/information",
      params: data
    })
  },
  
  updateInformation: (data) => {
     return axios({
       method: "PUT",
       url: "/admin/v2/information/" + data.id,
       data
     })
   },
   delInformation: (informationId) => {
     return axios({
       method: "DELETE",
       url: "/admin/v2/information/" + informationId
     })
   },
   detailInformation: (informationId) => {
     return axios({
       method: "GET",
       url: "/admin/v2/information/" + informationId
     })
   },
   // 通知
   addNotice: (data) => {
      return axios({
        method: "POST",
        url: "/admin/v2/notice",
        data
      })
    },
   getNoticeList: (data) => {
     return axios({
       method: "get",
       url: "/admin/v2/notice",
       params: data
     })
   },
   
   updateNotice: (data) => {
      return axios({
        method: "PUT",
        url: "/admin/v2/notice/" + data.id,
        data
      })
    },
    delInNotice: (noticeId) => {
      return axios({
        method: "DELETE",
        url: "/admin/v2/notice/" + noticeId
      })
    },
    detailNotice: (noticeId) => {
      return axios({
        method: "GET",
        url: "/admin/v2/notice/" + noticeId
      })
    },
   
   getSystemUserList: (data) => {
     return axios({
       method: "POST",
       url: "/admin/v2/systemUser",
       data
     })
   },
   
   systemRecommend: (data) => {
     return axios({
       method: "POST",
       url: "/admin/v2/systemRecommend",
       data
     })
   },
   
   companyList: (data) => {
     return axios({
       method: "GET",
       url: "/admin/v2/company",
       params: data
     })
   },
   companyEdit: (data) => {
     return axios({
       method: "PUT",
       url: "/admin/v2/company/"+ data.companyId,
       data
     })
   },
   
   messageList: (data) => {
     return axios({
       method: "GET",
       url: "/admin/v2/noticeList",
       params: data
     })
   },
   messageDetail: (noticeId) => {
     return axios({
       method: "GET",
       url: "/admin/v2/noticeDetail/"+ noticeId
     })
   },
}
export default userInfo;
